import { IPayrollSettings } from "@wingspanhq/payments/dist/interfaces";
import { TaxYear } from "../../../shared/constants/taxYear";

export const selectorCurrentYearFilingSettingsEnabled = (
  settings: IPayrollSettings,
  year: TaxYear
) => {
  const filingSettings =
    settings.calculationSettings1099?.filingSettings?.[year];

  return filingSettings?.filingEnabled;
};
